import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c110a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header bg-white" }
const _hoisted_3 = { class: "card-title d-flex flex-row justify-content-between" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "d-flex flex-column align-items-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock" }, null, -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Dieses Ticket wurde erstellt durch ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-3" }, " Ticketverlauf ", -1))
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "list-feed list-feed-rhombus" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "text-prewrap" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-3" }, " Auf das Ticket antworten ", -1))
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-form-label" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-form-label" }
const _hoisted_25 = { class: "d-flex flex-row align-items-start" }
const _hoisted_26 = { class: "btn btn-secondary mr-3 flex-0 text-nowrap" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Dateien auswählen ")
const _hoisted_28 = { class: "d-flex flex-row flex-wrap align-items-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mr-2 font-size-lg" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times-circle" }, null, -1))
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-attachment" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.ticket.name) + " | ", 1),
            _createElementVNode("small", null, "#" + _toDisplayString(_ctx.ticket.id), 1)
          ]),
          _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.ticket.extendName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("small", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.date), 1)
          ]),
          _createElementVNode("small", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.ticket.time), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("b", null, _toDisplayString(_ctx.ticket.createdByFullName), 1)
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticket.logs, (log, logIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: logIndex,
              class: "list-feed-item d-flex flex-row justify-content-between align-items-start"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("b", null, _toDisplayString(log.createdByFullName), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(log.text), 1)
              ]),
              _createElementVNode("small", _hoisted_17, _toDisplayString(log.date) + " " + _toDisplayString(log.time), 1)
            ]))
          }), 128))
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.frm.message.name), 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            rows: "4",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.message.value) = $event))
          }, null, 512), [
            [_vModelText, _ctx.frm.message.value]
          ])
        ])
      ]),
      (_ctx.showAttachments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.frm.files.name), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("input", {
                    type: "file",
                    multiple: "",
                    class: "d-none",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFilesChange && _ctx.onFilesChange(...args)))
                  }, null, 32)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frm.files.value, (file, fileIndex) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: fileIndex,
                      class: "badge bg-accent mr-1 mb-1 cursor-pointer",
                      onClick: ($event: any) => (_ctx.removeFile(fileIndex))
                    }, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(file.name), 1),
                      _hoisted_31
                    ], 8, _hoisted_29))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        (!_ctx.showAttachments)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-accent-100 text-accent btn-sm mr-2 ml-2",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showAttachments = true), ["stop"]))
            }, _hoisted_34))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.responseTicket && _ctx.responseTicket(...args)))
        }, "Antworten")
      ])
    ])
  ]))
}